const color = [
    'nav-primary',
    'nav-secondary',
    'nav-success',
    'nav-warning',
    'nav-danger',
    'nav-info',
    'nav-light',
    'nav-dark',
];

// ----------------------------------------------------------------------------

export { color };
